export enum DateFilterTypeEnum {
  IN,
  FROM,
  BEFORE,
  AFTER,
  BETWEEN,
}
